import { render, staticRenderFns } from "./payrollslip.vue?vue&type=template&id=6f47d6d4"
import script from "./payrollslip.vue?vue&type=script&lang=js"
export * from "./payrollslip.vue?vue&type=script&lang=js"
import style0 from "./payrollslip.vue?vue&type=style&index=0&id=6f47d6d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports